import './instrument';

import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <Sentry.ErrorBoundary
        fallback={<p>Something went wrong in the admin panel.</p>}
      >
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
}
